function parseBrazilianNumber(input, fallback) {
  const cleaned = input.replace(",", ".");
  const parsed = Number(cleaned);
  return isNaN(parsed) ? fallback : parsed;
}
function IsNumber(input) {
  const cleaned = input.replace(",", ".");
  const parsed = Number(cleaned);
  return !isNaN(parsed);
}
export {
  IsNumber,
  parseBrazilianNumber
};